/**
 * Client-side feature gate. Used for UI hints only — display "this is gated"
 * without claiming to be a security boundary. Server-side enforcement lives
 * in /netlify/functions/_lib/feature-flags.js (Algorithm Pro pattern).
 *
 * The two files share the same tier matrix; they're maintained in lockstep.
 * If the FEATURE_MIN_TIER map ever drifts between them, the server is the
 * authoritative source.
 */

const TIERS = ["recruiter", "manager", "hr_director", "enterprise"];

const FEATURE_MIN_TIER = {
  // Candidate Breakdown (LOCKED 2026-05-25 rename of "Resume Blueprint").
  // Single tier gate now that the Pre-Offer / Post-Offer mode-gate is removed.
  candidate_breakdown:               "recruiter",
  // Legacy aliases — see netlify/functions/_lib/feature-flags.js for rationale.
  resume_blueprint_pre_offer:        "recruiter",
  resume_blueprint_post_offer:       "recruiter",

  pre_meeting_standard:              "recruiter",
  pre_meeting_conflict_mediation:    "manager",         // V1.0 mode_variant; Recruiter excluded — mirrors server map at netlify/functions/_lib/feature-flags.js
  pre_meeting_layoff:                "hr_director",
  pre_meeting_pip:                   "hr_director",
  pre_meeting_disciplinary:          "hr_director",

  operating_manual:                  "recruiter",
  profile_sharing_within_team:       "manager",
  profile_sharing_org_wide:          "hr_director",
  employee_self_view:                "hr_director",
  hr_fairness_audit:                 "hr_director",

  relational_blueprint:              "recruiter",
  relational_blueprint_on_behalf_of: "hr_director",

  negotiation_blueprint:             "manager",
  common_ground:                     "manager",
  thought_engineering:               "manager",

  team_blueprint:                    "manager",
  multi_team_comparison:             "manager",

  calendar_integration:              "recruiter",

  branded_portal:                    "enterprise",
  custom_section_templates:          "enterprise",
  partner_audit_isolation:           "enterprise",
};

function tierIndex(tier) {
  return TIERS.indexOf(tier);
}

export function canAccess(tier, feature) {
  const min = FEATURE_MIN_TIER[feature];
  if (!min) return true;
  return tierIndex(tier) >= tierIndex(min);
}

export function tierDisplayLabel(tier) {
  return {
    recruiter: "Core",
    manager: "Pro",
    hr_director: "Advanced",
    enterprise: "Enterprise",
  }[tier] || tier;
}

export { FEATURE_MIN_TIER, TIERS };
